import apiService from './api';
import { Paginacao } from '../types';

/**
 * Notificações que aparecem no sininho do cabeçalho.
 *
 * Espelha o model `Notificacao` do servidor (backend/app/Models/Notificacao.php).
 * `dados` carrega o contexto do aviso (ex.: id do motorista) e hoje não é
 * consumido pela interface — tipado como registro aberto em vez de `any` para
 * não perder a checagem de tipos no restante do objeto.
 */
export interface Notificacao {
  id: number;
  tipo: string;
  titulo: string;
  mensagem: string;
  dados: Record<string, unknown> | null;
  lida: boolean;
  lida_em: string | null;
  created_at: string;
  updated_at: string;
}

export interface ListaNotificacoesResponse {
  success: boolean;
  data: Notificacao[];
  pagination: Paginacao;
}

export interface ContagemNaoLidasResponse {
  success: boolean;
  data: { count: number };
}

export interface AcaoNotificacaoResponse {
  success: boolean;
  message: string;
}

export const notificacoesService = {
  // `page`/`perPage` sao opcionais: sem eles o servidor aplica o proprio padrao
  // e o sininho do cabecalho continua chamando `listar()` sem argumento.
  // `apenasNaoLidas` deixa de fora o que ja foi visto. O sininho usa isso: sem
  // o filtro, um aviso clicado sumia da lista e voltava assim que o usuario
  // reabrisse o menu, porque a consulta seguinte trazia o historico inteiro.
  listar: async (page?: number, perPage?: number, apenasNaoLidas?: boolean) => {
    const params = new URLSearchParams();
    if (page !== undefined) params.append('page', String(page));
    if (perPage !== undefined) params.append('per_page', String(perPage));
    if (apenasNaoLidas) params.append('apenas_nao_lidas', '1');
    const query = params.toString();
    return apiService.get<ListaNotificacoesResponse>(`/v1/notificacoes${query ? '?' + query : ''}`);
  },

  naoLidas: async () =>
    apiService.get<ContagemNaoLidasResponse>('/v1/notificacoes/nao-lidas'),

  marcarLida: async (id: number) =>
    apiService.post<AcaoNotificacaoResponse>(`/v1/notificacoes/${id}/lida`),

  marcarTodasLidas: async () =>
    apiService.post<AcaoNotificacaoResponse>('/v1/notificacoes/marcar-todas-lidas'),
};
